import * as React from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { ScrollPanel } from 'primereact/scrollpanel';
import { Col, Row, Card, CardHeader, CardBody, Button as FButton } from "reactstrap";
import { useParams } from "react-router-dom";
import { resolveAddress } from "../../utils/position";
import PositionWaiting from "../../components/position/PositionWaiting";
import getCommandsCard from "../../components/position/getCommandsCard";
import PositionMap from "../../components/position/PositionMap";
import PositionView from "../../components/position/PositionView";
import CustomerView from "../../components/position/CustomerView";
import VehicleView from "../../components/position/VehicleView";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import PageLayout from "../../components/PageLayout";
import { getTicket, updateTicket } from "../../api/tickets";
import { getVehicle } from "../../api/vehicles"
import { getCustomer } from "../../api/customers"
import { Timeline, TimelineEvent } from 'react-event-timeline';
import ReactJson from 'react-json-view'
import ViewCustVehDev from "../../components/DeviceVehCustModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TabView, TabPanel } from 'primereact/tabview';


export default function WorkTicket() {
    const google = window.google;
    const { ticketId } = useParams();
    const [lastCommandResult, setResult] = React.useState();
    const [gapMapObj, setMapInstance] = React.useState();
    const [position, setPosition] = React.useState();
    const [address, setAddress] = React.useState("");
    const [vehicle, setVehicle] = React.useState("");
    const [customer, setCustomer] = React.useState("");
    const [ticket, setTicket] = React.useState();
    const [device, setDevice] = React.useState();
    const [gisDeviceStatus, setGisDeviceStatus] = React.useState("offline");
    const { eventBus, gisApi, domains, user } = useAuth0();
    const [closed, setClosed] = React.useState(false)
    const [saving, setSaving] = React.useState(false)
    const noteRef = React.createRef()
    const [customButton, disableCustomButton] = React.useState("");
    const { push } = useHistory()

    React.useEffect(() => {
        loadTicket();
    }, [])

    React.useEffect(() => {
        if (!ticket || closed) return;
        const socketPromise = connectSocket();
        // Specify how to clean up after this effect:
        return async function cleanup() {
            const socket = await socketPromise;
            socket.close(1000, "cleanuppage");
        };
    }, [ticket]);

    React.useEffect(() => {
        if (gapMapObj && position && !closed) {
            const newPoint = new google.maps.LatLng(
                position.latitude,
                position.longitude
            );
            gapMapObj.map.setCenter(newPoint);
            gapMapObj.map.panTo(newPoint);
        }
    });

    React.useEffect(() => {
        if (!saving && noteRef.current) noteRef.current.value = ""
    }, [saving])

    React.useEffect(() => {
        if (!ticket || closed) return;
        loadVehicle();
    }, [ticket])

    React.useEffect(() => {
        if (!ticket || closed) return;
        loadCustomer();
    }, [ticket])

    async function loadTicket() {
        const tktRes = await getTicket(ticketId);
        setTicket(tktRes);
        setClosed(tktRes.status === "chiuso");
        disableCustomButton(true);
    }

    async function loadVehicle() {
        const vehicle = await getVehicle(ticket.attributes.vehicle_id);
        setVehicle(vehicle);
    }

    async function loadCustomer() {
        const customer = await getCustomer(ticket.attributes.customer_id);
        setCustomer(customer);
    }

    async function closeTicket() {
        try {
            setSaving(true)
            const list = ticket.notes.list.concat({ time: moment().utc(), text: "Ticket chiuso", createdBy: user.email });
            const tt = { ...ticket, status: "chiuso", notes: { list } }
            const nt = await updateTicket(tt);
            setTicket(nt);
            setClosed(true)
        } finally {
            setSaving(false)
        }
    }

    async function reopenTicket() {
        try {
            setSaving(true)
            const list = ticket.notes.list.concat({ time: moment().utc(), text: "Ticket riaperto", createdBy: user.email });
            const tt = { ...ticket, status: "aperto", notes: { list } }
            const nt = await updateTicket(tt);
            setTicket(nt)
            setClosed(false)
        } finally {
            setSaving(false)
        }
    }

    async function addNote() {
        try {
            setSaving(true)
            const list = ticket.notes.list.concat({ time: moment().utc(), text: noteRef.current.value, createdBy: user.email });
            const tt = { ...ticket, notes: { list } }
            const nt = await updateTicket(tt);

            setTicket(nt)
        } finally {
            setSaving(false)
        }
    }

    function onMapReady(map) {
        setMapInstance(map);
    }

    async function updatePosition(position) {
        setPosition(position);

        try {
            const addr = await resolveAddress(position);
            setAddress(addr);
        } catch (error) {
            // unable to resolve address but we keep going
            console.log(error);
        }
    }

    async function connectSocket() {
        const gisDevice = await initData(ticket);

        if (!gisDevice) {
            eventBus.dispatchEvent(
                new CustomEvent("growl", {
                    detail: {
                        message: {
                            type: "error",
                            summary: "Errore Ticket",
                            content: `Impossibile verificare i dati GIS per il dispositivo ${ticket.attributes.imei}`
                        }
                    }
                })
            );
        }

        setDevice(gisDevice);

        const socket = new WebSocket(`${domains.appSettings.gisWs}/api/socket`);

        socket.onclose = evt => {
            if (evt.reason !== "cleanuppage") {
                setTimeout(() => connectSocket(), 60 * 1000);
            }
        };

        socket.onmessage = event => {
            const data = JSON.parse(event.data);

            if (data.positions) {
                const devicePositions = data.positions.filter(
                    el => el.deviceId === gisDevice.id
                );
                const pos = devicePositions.length && devicePositions[0];
                if (pos) {
                    console.log(pos);
                    eventBus.dispatchEvent(
                        new CustomEvent("POSITION", {
                            detail: { position: pos }
                        })
                    );
                    updatePosition(pos);
                }
                if (pos && pos.attributes.result) {
                    setResult(pos.attributes.result);
                    console.log(pos);
                    eventBus.dispatchEvent(
                        new CustomEvent("growl", {
                            detail: {
                                message: {
                                    type: "success",
                                    summary: "Risultato comando",
                                    content: pos.attributes.result
                                }
                            }
                        })
                    );
                    eventBus.dispatchEvent(
                        new CustomEvent("GISRESULT", {
                            detail: { position: pos }
                        })
                    );
                }
            }

            if (data.events) {
                const deviceEvents = data.events.filter(
                    el => el.deviceId === gisDevice.id
                );
                const evt = deviceEvents.length && deviceEvents[0];
                if (evt) {
                    console.log(evt);
                    eventBus.dispatchEvent(
                        new CustomEvent("growl", {
                            detail: {
                                message: {
                                    type: "info",
                                    summary: "EVENTO",
                                    content: `${moment(evt.serverTime).format(
                                        "DD/MM/YYYY HH:mm:ss"
                                    )} ${evt.type}`
                                }
                            }
                        })
                    );
                }
            }

            if (data.devices) {
                const deviceInfo = data.devices.filter(el => el.id === gisDevice.id);
                const info = deviceInfo.length && deviceInfo[0];
                if (info) {
                    console.log('stato dispositivo', info);
                    setGisDeviceStatus(info.status);
                }
            }
        };

        return socket;
    }

    async function initData(ticket) {
        await gisApi.login();
        let gisDevice = await gisApi.getDevice(ticket.attributes.imei);
        return gisDevice;
    }

    function getPositionDetails(position) {
        if (!position || closed) return null;

        return (
            <Row>
                <Col xs="12">
                    <PositionMap
                        position={position}
                        onMapReady={onMapReady}
                        gisDeviceStatus={gisDeviceStatus}
                    />
                </Col>
            </Row>
        );
    }

    function getTicketTimeline() {
        if (!ticket || !ticket.notes) return null;
        return (<Row className="mt-2">
            <Col xs="12" >
                <Card className="card-box mb-3">
                    <CardHeader>
                        <h4 className="font-size-lg mb-0 py-0 font-weight-bold">
                            Storico Ticket
                        </h4>
                    </CardHeader>
                    <CardBody className="px-2 pt-3">
                        <Timeline>
                            <ScrollPanel style={{ width: '100%', height: '340px' }} className="custombar">
                                {(ticket.notes.list || []).map((evt, i) => (

                                    <TimelineEvent
                                        key={i}
                                        title={`${moment(evt.time).format('DD/MM/YYYY HH:mm:ss')} - Nota aggiunta da Operatore ${evt.createdBy || ticket.createdby}`}
                                        //subtitle=""
                                        icon={<i className="far fa-calendar" />}
                                        container="card"
                                        collapsible
                                        showContent
                                        style={{
                                            border: '1px solid #777',
                                            borderRadius: 3
                                        }}
                                        cardHeaderStyle={{
                                            backgroundColor: closed ? '#8bc34a' : '#3490dc'
                                        }}
                                    >
                                        {evt.text}
                                    </TimelineEvent>
                                ))}
                            </ScrollPanel>
                        </Timeline>
                        <div className="mt-2" style={{ width: "100%" }}>
                            <textarea rows={3} style={{ width: "100%", padding: "5px" }} ref={noteRef}></textarea>
                        </div>
                        <div className="action-container mt-2">
                            {!closed ? <FButton color="success" className="mr-1" onClick={closeTicket} disabled={saving}> <FontAwesomeIcon icon="power-off" spin={saving} /> Chiudi Ticket</FButton> : <FButton color="warning" className="mr-1" onClick={reopenTicket} disabled={saving}> <FontAwesomeIcon icon="lock-open" spin={saving} /> Riapri Ticket</FButton>}
                            <FButton color="info" disabled={saving} onClick={addNote}>  <FontAwesomeIcon icon="pencil-alt" spin={saving} /> Aggiungi Nota</FButton>
                            <div className="float-right"><FButton color="warning" onClick={() => { push(`/centrale/tickets`); }}> <FontAwesomeIcon icon="list" /> Torna all'elenco</FButton></div>
                        </div>
                    </CardBody>
                </Card>

            </Col>
        </Row>)
    }

    function getCommands(position) {
        if (!position || closed) return null;
        return (
            <Row>
                <Col xs="12">
                    {getCommandsCard(device, position, customButton)}
                </Col>
            </Row>
        );
    }

    function getPositionWaiting(position) {
        if (position || closed) return null;
        return (<PositionWaiting
            display
            onRefresh={() => window.location.reload()}
        />)
    }

    return (
        <PageLayout
            title={ticket ? `${ticket.attributes.customer_name} - Targa: ${ticket.attributes.plate} Tel. dispositivo: ${ticket.attributes.number} IMEI: ${ticket.attributes.imei}` : '...'}
            optionalNav={{ link: "/centrale/tickets", text: "Ticket" }}
        >
            <Row>
                <Col xs="6">
                    {getPositionWaiting(position)}
                    {getTicketTimeline()}
                </Col>
                <Col xs="6">
                    <TabView>
                        <TabPanel header="Mappa">
                            {getPositionDetails(position)}
                        </TabPanel>
                        <TabPanel header="Posizione">
                            <PositionView
                                position={position}
                                address={address}
                                vehicle={vehicle}
                                lastCommandResult={lastCommandResult}
                            />
                        </TabPanel>
                    </TabView>
                </Col>
                <Col xs="6">
                    <CustomerView
                        customer={customer}
                    />
                </Col>
                <Col xs="6">
                    <VehicleView
                        vehicle={vehicle}
                    />
                    {getCommands(position)}
                </Col>
            </Row>
        </PageLayout>
    );
}
